define(function(require) {
    'use strict';
    var UserModel = require('../user.model');
    module.exports = UserModel.extend({
        cachedAttributes: [...UserModel.prototype.cachedAttributes, 'cellphoneAvailabilityVerificationToken']
    });
});